import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

import {
  getCurrentPartner,
  getCurrentPartnerId,
  getIdentityPartners,
  getIdentityPortalUser,
  getIdentityPortalSuperuser,
} from 'selectors/settings'

import SuperUserBar from './super-user-bar'
import SuperUserBarPartner from './super-user-bar-partner'

export class SuperUserBarContainer extends Component {

  render() {
    if (this.props.portalSuperuser && this.props.portalUser &&
        this.props.portalSuperuser.id !== this.props.portalUser.id) {
      return <SuperUserBar portalSuperuser={this.props.portalSuperuser} portalUser={this.props.portalUser} />
    }
    if (this.props.portalUser && this.props.portalUser.isStaffUser &&
        this.props.portalUserPartners.indexOf(Number(this.props.partnerId)) === -1) {
      const partnerName = this.props.partner ? this.props.partner.name : ''
      return <SuperUserBarPartner partnerName={partnerName} />
    }
    return null
  }

}

SuperUserBarContainer.propTypes = {
  partner: PropTypes.object,
  partnerId: PropTypes.string,
  portalSuperuser: PropTypes.object,
  portalUser: PropTypes.object,
  portalUserPartners: PropTypes.array,
}

const mapStateToProps = state => ({
  partner: getCurrentPartner(state),
  partnerId: getCurrentPartnerId(state),
  portalSuperuser: getIdentityPortalSuperuser(state),
  portalUser: getIdentityPortalUser(state),
  portalUserPartners: getIdentityPartners(state),
})

export default connect(mapStateToProps)(SuperUserBarContainer)



/** WEBPACK FOOTER **
 ** ./src/components/super-user-bar/super-user-bar-container.js
 **/